export var NetworkType;
(function (NetworkType) {
    NetworkType["MAINNET"] = "mainnet";
    NetworkType["DELPHINET"] = "delphinet";
    NetworkType["EDONET"] = "edonet";
    NetworkType["FLORENCENET"] = "florencenet";
    NetworkType["GRANADANET"] = "granadanet";
    NetworkType["HANGZHOUNET"] = "hangzhounet";
    NetworkType["CUSTOM"] = "custom";
})(NetworkType || (NetworkType = {}));
//# sourceMappingURL=NetworkType.js.map